import {IUpdateConnectionStatusAction, UPDATE_CONNECTION_STATUS} from './types/connectionStatus.action.types';
import {IConnectionStatus} from '../../incase-domain/connectionStatus';

export const updateConnectionStatusAction = (connectionStatus: IConnectionStatus): IUpdateConnectionStatusAction => ({
    type: UPDATE_CONNECTION_STATUS,
    payload: connectionStatus,
});
